import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { Style, WebSearch } from '@local/client-contracts';
import { LogService } from '@shared/services';
import { Logger } from '@unleash-tech/js-logger';
import { WebSearchItem } from '../../results';

@Component({
  selector: 'web-search-results-item',
  templateUrl: './web-search-results-item.component.html',
  styleUrls: ['./web-search-results-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebSearchResultItemComponent implements OnInit {
  @Input() model: WebSearch.ResultItem;
  @Input() engine: string;
  @Input() set selected(value: boolean) {
    this._selected = value;
  }
  @Input() firstResult: number;

  get selected() {
    return this._selected;
  }

  private logger: Logger;
  private _selected: boolean;
  fallbackIcon: Style.EntityIcon<Style.EntityIconType>;
  showFallback: boolean;
  constructor(private logService: LogService) {}

  @HostBinding('class.one-line') get isOneLine() {
    return !this.model.view?.subtitle;
  }

  ngOnInit() {
    if (!this.engine) {
      this.engine = (this.model as WebSearchItem).engine;
    }
    this.fallbackIcon = { type: 'img', value: { lightUrl: `assets/bar/web-search/${this.engine.toLowerCase()}.svg` } };
    this.logger = this.logService.scope('WebSearchResultItemComponent', {
      id: this.model.id,
      engine: this.engine,
      text: this.model.view.title.text,
    });
  }
}
